import { IconButton, SvgIcon } from "@material-ui/core";
import classNames from "classnames";
import React from "react";
import { isEmpty } from "../helpers";
import "./BB8TextSearch.scss";

export interface IBB8TextSearchState {
  isDirty: boolean;
  isValid: boolean;
  isTouched: boolean;
  text: string;
}

export interface IBB8TextSearchProps {
  placeholder?: string;
  onSearch: (text: string) => void;
  validators?: Array<(text: string) => boolean>;
  initialText?: string;
}

export class BB8TextSearch extends React.Component<
  IBB8TextSearchProps,
  IBB8TextSearchState
> {
  public state = {
    isDirty: false,
    isTouched: this.props.initialText !== undefined || false,
    isValid: true,
    text: ""
  };

  public render() {
    const { placeholder, initialText } = this.props;
    const { isDirty, isValid } = this.state;
    const classes = classNames("bb8-search", {
      dirty: isDirty,
      invalid: !isValid,
      valid: isValid
    });
    return (
      <form className="bb8-search-wrapper" onSubmit={this.triggerSearch}>
        <input
          type="text"
          name="search"
          className={classes}
          placeholder={placeholder}
          onChange={this.handleChange}
          defaultValue={initialText}
          value={this.state.text}
          onBlur={this.handleBlur}
        />
        <IconButton
          className="bb8-search-icon"
          disabled={!isValid}
          onClick={this.triggerSearch}
        >
          <SvgIcon>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
            >
              <path
                fill="#6B6B6B"
                d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"
              />
              <path d="M0 0h24v24H0z" fill="none" />
            </svg>
          </SvgIcon>
        </IconButton>
      </form>
    );
  }

  private handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    this.update(event.target.value);
  };

  private handleBlur = (event: React.FocusEvent<HTMLInputElement>) => {
    this.update(event.target.value);
  };

  private update = (text: string) => {
    this.setState(() => {
      // const t = text || currentState.text;
      return {
        isDirty: !isEmpty(text),
        isTouched: true,
        isValid: this.checkIfValid(text),
        text
      };
    });
  };

  private triggerSearch = (
    event: React.KeyboardEvent | React.MouseEvent | React.FormEvent
  ) => {
    if (event) {
      event.preventDefault();
      if (this.state.isValid) {
        this.props.onSearch(this.state.text);
      }
    }
  };

  private checkIfValid = (str: string | undefined) => {
    if (str === undefined) {
      return true;
    }
    const { validators } = this.props;
    if (isEmpty(str) || !validators) {
      return true;
    }
    return this.state.isTouched && validators.every(v => v(str));
  };
}

export default BB8TextSearch;
